import { defineRoutes } from "@/service/routing/schema";

const base = "/uslugi";

export const serviceRoutes = defineRoutes({
  "service.index": `${base}`,
  "service.sport": `${base}/sport-i-aktywnosc`,
  "service.practice": `${base}/praktyka-lekarska`,
  "service.practice.infakt": `${base}/praktyka-lekarska/infakt`,
  "service.practice.infakt.pkd": `${base}/praktyka-lekarska/infakt/kody-pkd`,
  // Publiczny landing usługi — poza /uslugi, bo prowadzi na niego ruch z reklam.
  "service.practice.infakt.landing": `/infakt`,
  "service.sport.medicover_sport": `${base}/sport-i-aktywnosc/medicover-sport`,
  // Publiczny landing usługi — poza /uslugi, bo prowadzi na niego ruch z reklam.
  "service.sport.medicover_sport.landing": `/medicover-sport`,
} as const);
